import {inviteTeamMember} from '@/api/team';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import type {InviteTeamMemberRequest} from '@/types/api';

export function useInviteTeamMember() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: InviteTeamMemberRequest) => inviteTeamMember(data),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['teamMembers']});
        }
    });
}
